<template>
    <v-layout>
        <v-flex xs12>
            <div :style="enforceMinWidth ? 'overflow-x: auto' : ''">
            <v-card v-bind:class="[itemDefinition.renderAsReport ? 'carnot-custom-report': null, reportIsPrinting ? 'page-under-print': null]" :light="whiteMode" :style="enforceMinWidth ? 'min-width: 1840px;' : ''" :flat="fullscreenMode">
                <v-card-title class="accent white--text title" v-if="!embeddedMode&&!fullscreenMode">
                    {{itemDefinition.title|translate}}
                </v-card-title>
                <v-card-text style="padding-top: 0; bottom: 0;" v-if="!embeddedMode&&!reportIsPrinting" :style="itemDefinition.showBoxes&&!itemDefinition.renderAsReport&&itemDefinition.backgroundColor ? 'background-color:'+itemDefinition.backgroundColor : ''">
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="range" v-show="!itemDefinition.hideRangeSelector" :month-mode="itemDefinition.monthMode"
                                                 :use-month-range="itemDefinition.useMonthRange" :use-custom-month="itemDefinition.useCustomMonth"
                                                 :custom-month-min="itemDefinition.customMonthMin"
                                                 :icon-mode="itemDefinition.dateIconMode"
                                                 :lock-start-range="itemDefinition.lockStartRange"
                                                 :custom-month-range-json="itemDefinition.customMonthRangeJson"></date-range-selector>
                            <div style="width: 360px" v-if="itemDefinition.hasEquipmentSelector&&!reloadingSelectors&&!itemDefinition.allEquipsMode">
                                <equipment-selector v-model="equip" :type-filter="itemDefinition.equipmentTypeFilter" :floor-filter="itemDefinition.equipmentFloorFilter"
                                :tag-filter="itemDefinition.equipmentTagFilter" ></equipment-selector>
                            </div>
                            <v-switch color="success"
                                    v-model="onOnly"
                                    v-if="itemDefinition.hasOnOnlySwitch"
                                    :label="'On Only'|translate"
                            ></v-switch>

                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text style="padding-top: 0;" class="carnot-custom-view" :style="itemDefinition.showBoxes&&!itemDefinition.renderAsReport&&itemDefinition.backgroundColor ? 'background-color:'+itemDefinition.backgroundColor : ''"
                             v-bind:class="[itemDefinition.renderAsReport&&whiteMode ? 'carnot-custom-report-white': null]"
                             >
                    <v-layout row wrap>
                        <v-flex v-for="plot in currentViewComponents" :key="itemDefinition.title+plot.id"  v-bind:class="[plot['flex-class'], 'xs12',plot['pageBreak'] ? 'page-break': null]" >
                            <data3-chart ref="plots" v-if="plot.type==='data3-chart'"
                                         :layout-overrides="plot.config['layout-overrides']"
                                         :on-only="onOnly"
                                         :x-axis="plot.config['x-axis']"
                                         :y-axis="plot.config['y-axis']"
                                         :color-axis="plot.config['color-axis']"
                                         :marker-size-axis="plot.config['marker-size-axis']"
                                         :color-axis-scale="plot.config['color-axis-scale']"
                                         :color-axis-title="plot.config['color-axis-title']"
                                         :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                         :show-errors="debugMode"
                                         :parameters="parameters"
                                         disable-responsive
                                         show-units
                                         :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                         :data-payload="plot.config['data-payload']"
                                         :independent-x="plot.config['independent-x']"
                                         :series-overrides="plot.config['series-overrides']"
                                         :white-mode="whiteMode"
                                         :date-range="range"></data3-chart>
                            <div v-if="plot.type==='html'&&(!itemDefinition.renderAsReport||plot['pageBreak'])" v-html="plot.config.html" class="ck-rendered-content" :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "></div>
                            <div v-if="plot.type==='html'&&itemDefinition.renderAsReport&&!plot['pageBreak']"  class="split-ck-rendered-content" :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' ">
                                <div v-for="html in splitHTML(plot.config.html)" class="ck-rendered-content" v-html="html"></div>
                            </div>
                            <div v-if="plot.type==='parameter-widget'" :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' ">
                                <v-card flat v-if="plot.config.fields">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="field in plot.config.fields" v-if="field.name">
                                                <v-slider
                                                    :label="field.label"
                                                    v-model.number="parameters[field.name]"
                                                    :min="field.min"
                                                    :max="field.max"
                                                    :step="field.step"
                                                    thumb-label="always"
                                                ></v-slider>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </div>
                            <div v-if="plot.type==='code'" v-html="plot.config.html" :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "></div>
                            <map-widget v-if="plot.type==='map-widget'"
                                        :height="plot.config.height"
                                        :map-token="plot.config.mapToken"
                                        :map-style="plot.config.mapStyle"
                                        :pitch="plot.config.pitch"
                                        :zoom="plot.config.zoom"
                                        :center-lon="plot.config.centerLon"
                                        :center-lat="plot.config.centerLat"
                                        :markers="plot.config.markers"
                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                        :date-range="range"
                                        :data3query="plot.config.data3query"
                                        :colors="plot.config.colors"
                            ></map-widget>
                            <heatmap-widget v-if="plot.type==='heatmap-widget'"
                                            :date-range="range"
                                            :height="plot.config.height"
                                            :width="plot.config.width"
                                            :min="plot.config.min"
                                            :max="plot.config.max"
                                            :image-url="plot.config.imageUrl"
                                            :points="plot.config.points"
                                            :agg="plot.config.agg"
                                            :agg-opp="plot.config.aggOpp"
                                            :options="plot.config.options"
                                            :on-only="plot.config.onOnly"
                                            :player="plot.config.player"
                                            :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                            ></heatmap-widget>
                            <correlation-widget v-if="plot.type==='correlation-widget'"
                                                :date-range="range"
                                                :white-mode="whiteMode"
                                                :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                :equipment-name="plot.config.equipmentName">
                            </correlation-widget>
                            <optimization-widget v-if="plot.type==='optimization-widget'"
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :exact-power-sensor="plot.config.exactPowerSensor"
                                                 :weather-sensor="plot.config.weatherSensor"
                                                 :weather-agg="plot.config.weatherAgg"
                                                 :hide-kpi="plot.config.hideKpi"
                                                 :weather-title="plot.config.weatherTitle"
                                                 :white-mode="whiteMode"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                 :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :cut-off="plot.config.cutOff"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :min-power="plot.config.minPower"
                                                 :max-power="plot.config.maxPower"
                                                 :min-temp="plot.config.minTemp"
                                                 :max-temp="plot.config.maxTemp"
                                                 :agg-frequency="plot.config.aggFrequency"
                                                 :ec-mode="plot.config.ecMode"
                                                 :date-range="range"></optimization-widget>
                            <flexible-optimization-widget v-if="plot.type==='flexible-optimization-widget'"
                                                          :custom-interpolation="plot.config.customInterpolation"
                                                          :interpolation="plot.config.interpolation"
                                                          :power-sensor="plot.config.powerSensor"
                                                          :show-negative-monthly="plot.config.showNegativeMonthly"
                                                          :weather-sensor="plot.config.weatherSensor"
                                                          :weather-title="plot.config.weatherTitle"
                                                          :use-switch="plot.config.useSwitch"
                                                          :title="plot.config.title"
                                                          :post-interpolation="plot.config.postInterpolation"
                                                          :custom-post-interpolation="plot.config.customPostInterpolation"
                                                          :start-date="plot.config.startDate"
                                                          :end-date="plot.config.endDate"
                                                          :white-mode="whiteMode"
                                                          :cut-off="plot.config.cutOff"
                                                          :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                                          :resampling-factor="plot.config.resamplingFactor"
                                                          :switch-sensor="plot.config.switchSensor"
                                                          :show-calc="plot.config.showCalc"
                                                          :min-temp="plot.config.minTemp"
                                                          :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                          :hide-kpi="plot.config.hideKpi"
                                                          :max-temp="plot.config.maxTemp"
                                                          :ec-mode="plot.config.ecMode"
                                                          :data3query="plot.config.data3query"
                                                          :parameters="parameters"
                                                          :date-range="range"></flexible-optimization-widget>
                            <cop-savings-widget v-if="plot.type==='cop-savings-widget'"
                                                :custom-interpolation="plot.config.customInterpolation"
                                                :interpolation="plot.config.interpolation"
                                                :power-sensor="plot.config.powerSensor"
                                                :cooling-load-sensor="plot.config.coolingLoadSensor"
                                                :title="plot.config.title"
                                                :start-date="plot.config.startDate"
                                                :end-date="plot.config.endDate"
                                                :hide-kpi="plot.config.hideKpi"
                                                :cut-off="plot.config.cutOff"
                                                :switch-sensor="plot.config.switchSensor"
                                                :use-switch="plot.config.useSwitch"
                                                :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                :min-power="plot.config.minPower"
                                                :white-mode="whiteMode"
                                                :max-power="plot.config.maxPower"
                                                :use-filter="plot.config.useFilter"
                                                :filter-sensor="plot.config.filterSensor"
                                                :max-filter="plot.config.maxFilter"
                                                :min-filter="plot.config.minFilter"
                                                :min-cooling-load="plot.config.minCoolingLoad"
                                                :max-cooling-load="plot.config.maxCoolingLoad"
                                                :agg-frequency="plot.config.aggFrequency"
                                                :show-mean-cop="plot.config.showMeanCop"
                                                :ec-mode="plot.config.ecMode"
                                                :date-range="range"></cop-savings-widget>
                            <fault-breakdown-widget v-if="plot.type==='fdd-breakdown-widget'"
                                                    :vertical="plot.config.vertical"
                                                    :hide-table="plot.config.hideTable"
                                                    :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :group-mode="plot.config.groupMode"
                                                    :critical-color="plot.config.criticalColor"
                                                    :high-color="plot.config.highColor"
                                                    :medium-color="plot.config.mediumColor"
                                                    :low-color="plot.config.lowColor"
                                                    :colorway="plot.config.colorway"
                                                    :title1="plot.config.title1"
                                                    :title2="plot.config.title2"
                                                    :label-margin="plot.config.labelMargin"
                                                    :white-mode="whiteMode"
                                                    :date-range="range"></fault-breakdown-widget>
                            <notif-breakdown-widget v-if="plot.type==='notif-breakdown-widget'"
                                                    :white-mode="whiteMode"
                                                    :title="plot.config.title"
                                                    :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :facet="plot.config.facet"
                                                    :height="plot.config.height"
                                                    :limit="plot.config.limit"
                                                    :date-range="range"></notif-breakdown-widget>
                            <fault-eval-widget v-if="plot.type==='fault-eval-widget'"
                                               :rule="plot.config.rule"
                                               :title="plot.config.title"
                                               :value="plot.config.value"
                                               :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                               :cost="plot.config.cost"
                                               :equipment-name="plot.config.equipmentName"
                                               :relevant-variables="plot.config.relevantVariables"
                                               :white-mode="whiteMode"
                                               :on-only="plot.config.onOnly"
                                               :show-cost="plot.config.showCost"
                                               :date-range="range"></fault-eval-widget>
                          <staging-profile-widget v-if="plot.type==='staging-profile-widget'"
                                                  :title="plot.config.title"
                                                  :x-title="plot.config.xTitle"
                                                  :white-mode="whiteMode"
                                                  :y-title="plot.config.yTitle"
                                                  :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                  :date-range="range"></staging-profile-widget>
                            <faults-report-widget v-if="plot.type==='faults-report-widget'"
                                                  :show-anomaly="plot.config.showAnomaly"
                                                  :show-summary="plot.config.showSummary"
                                                  :severity-filter="plot.config.severityFilter"
                                                  :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                  :show-faults="plot.config.showFaults"
                                                  :report-mode="itemDefinition.renderAsReport"
                                                  :white-mode="whiteMode"
                                                  :date-range="range"></faults-report-widget>
                            <cooling-load-forecast-widget v-if="plot.type==='cooling-load-forecast-widget'"
                                                  :title="plot.config.title"
                                                  :actual-observed-value-legend="plot.config.actualObservedValueLegend"
                                                  :confidence-interval-legend="plot.config.confidenceIntervalLegend"
                                                  :expected-value-legend="plot.config.expectedValueLegend"
                                                  :fitted-value-legend="plot.config.fittedValueLegend"
                                                          :days-before="plot.config.daysBefore"
                                                  :white-mode="whiteMode"
                                                  :x-title="plot.config.xTitle"
                                                  :y-title="plot.config.yTitle"
                                                          :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                  :result-name="plot.config.resultName"
                                                  ></cooling-load-forecast-widget>
                            <chiller-sequencing-fla-widget v-if="plot.type==='chiller-sequencing-fla-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :white-mode="whiteMode"
                                                    :y-title="plot.config.yTitle"
                                                           :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :dateRange="range"
                                                ></chiller-sequencing-fla-widget>
                            <chiller-sequencing-delta-widget v-if="plot.type==='chiller-sequencing-delta-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                             :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :dateRange="range"
                                                    :white-mode="whiteMode"
                                                ></chiller-sequencing-delta-widget>
                            <cooling-load-vs-oat-widget v-if="plot.type==='cooling-load-vs-oat-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :dateRange="range"
                                                    :white-mode="whiteMode"
                            ></cooling-load-vs-oat-widget>
                            <bms-widget v-if="plot.type==='bms-widget'"
                                        :title="plot.config.title"
                                        :latest-only="plot.config.latestOnly"
                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                        :svg="plot.config.svg"></bms-widget>
                            <svg-widget v-if="plot.type==='svg-widget'"
                                        :data3query="plot.config.data3query"
                                        :style="plot.config.verticalOffset ? 'height:0px;' : ''"
                                        :vertical-offset="plot.config.verticalOffset"
                                        :parameters="parameters"
                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                        :date-range="range"
                                        :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                        :include-issues="plot.config.includeIssues"
                                        :no-reload="plot.config.noReload"
                                        :include-maintenance="plot.config.includeMaintenance"
                                        :include-config="plot.config.includeConfig"
                                        :svg="plot.config.svg"></svg-widget>
                            <forge-viewer-widget v-if="plot.type==='forge-viewer-widget'"
                                                 :selected-items="[plot.config.selectedItemID]"
                                                 :selection-color="plot.config.selectionColor"
                                                 :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :white-mode="whiteMode"
                                                 :use-min-height="plot.config.useMinHeight"
                                                 :url="plot.config.url" :height="plot.config.height"></forge-viewer-widget>
                            <forge-viewer-heatmap-widget
                                v-if="plot.type==='forge-viewer-heatmap-widget'"
                                :url="plot.config.url"
                                :date-range="range"
                                :points="plot.config.points"
                                :surface-id="plot.config.surfaceId"
                                :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                :floor-name="plot.config.floorName"
                                :agg="plot.config.agg"
                                :agg-opp="plot.config.aggOpp"
                                :white-mode="whiteMode"
                                :on-only="plot.config.onOnly"
                                :height="plot.config.height"></forge-viewer-heatmap-widget>
                            <flexible-cop-savings-widget v-if="plot.type==='flexible-cop-savings-widget'"
                                                         :custom-interpolation="plot.config.customInterpolation"
                                                         :interpolation="plot.config.interpolation"
                                                         :post-interpolation="plot.config.postInterpolation"
                                                         :custom-post-interpolation="plot.config.customPostInterpolation"
                                                         :power-sensor="plot.config.powerSensor"
                                                         :cooling-load-sensor="plot.config.coolingLoadSensor"
                                                         :title="plot.config.title"
                                                         :start-date="plot.config.startDate"
                                                         :resampling-factor="plot.config.resamplingFactor"
                                                         :end-date="plot.config.endDate"
                                                         :data3query="plot.config.data3query"
                                                         :parameters="parameters"
                                                         :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                         :cut-off="plot.config.cutOff"
                                                         :switch-sensor="plot.config.switchSensor"
                                                         :use-switch="plot.config.useSwitch"
                                                         :white-mode="whiteMode"
                                                         :hide-kpi="plot.config.hideKpi"
                                                         :show-mean-cop="plot.config.showMeanCop"
                                                         :span="plot.config.span"
                                                         :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                                         :band="plot.config.band"
                                                         :show-negative-monthly="plot.config.showNegativeMonthly"
                                                         :show-copy-btn="plot.config.showCopyBtn"
                                                         :post-interpolation-points="plot.config.postInterpolationPoints"
                                                         :degree="plot.config.degree"
                                                         :ec-mode="plot.config.ecMode"
                                                         :date-range="range"></flexible-cop-savings-widget>
                            <maintenance-summary-widget v-if="plot.type==='maintenance-summary-widget'"
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :white-mode="whiteMode"
                                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :height="plot.config.height"
                                                        :date-range="range"
                            ></maintenance-summary-widget>
                            <sensor-calibration-widget v-if="plot.type==='sensor-calibration-widget'"
                                                       :title="plot.config.title"
                                                       :conf="plot.config.conf"
                                                       :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                       :date-range="range"
                                                       :white-mode="whiteMode"
                            ></sensor-calibration-widget>
                            <clock-control-widget v-if="plot.type==='clock-control-widget'"
                                                       :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                       v-model="range"
                                                       :target="plot.config.target"
                                                  :title="plot.config.title"
                                                  :animate-mode="plot.config.animateMode"
                                                  :frame-duration="plot.config.frameDuration"
                                                  :frame-multiplier="plot.config.frameMultiplier"
                                                  :loop="plot.config.loop"
                            ></clock-control-widget>
                            <issue-summary-widget v-if="plot.type==='issue-summary-widget'"
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :title3="plot.config.title3"
                                                  :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :white-mode="whiteMode"
                                                        :height="plot.config.height"
                                                        :date-range="range"
                            ></issue-summary-widget>
                            <tree-map-widget v-if="plot.type==='tree-map-widget'"
                                             :title="plot.config.title"
                                             :power-sensor="plot.config.powerSensor"
                                             :agg-frequency="plot.config.aggFrequency"
                                             :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                             :height="plot.config.height"
                                             :unit="plot.config.unit"
                                             :white-mode="whiteMode"
                                             :date-range="range"
                            ></tree-map-widget>
                            <thermal-comfort-widget v-if="plot.type==='thermal-comfort-widget'"
                                                    :title="plot.config.title"
                                                    :height="plot.config.height"
                                                    :dryBulbTemp="plot.config.dryBulbTemp"
                                                    :radiantTemp="plot.config.radiantTemp"
                                                    :relativeHumidty="plot.config.relativeHumidty"
                                                    :airSpeed="plot.config.airSpeed"
                                                    :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :metabolicRate="plot.config.metabolicRate"
                                                    :clothingLevel="plot.config.clothingLevel"
                                                    :hide-parameters="plot.config.hideParameters"
                                                    :hide-temp-scale="plot.config.hideTempScale"
                                                    :white-mode="whiteMode"
                                                    :date-range="range"
                                                    :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                                    :parameters="parameters"
                                                    :data3query="plot.config.data3query"
                                                    :enable-solar="plot.config.enableSolar"
                                                    :solar-altitude="plot.config.solarAltitude"
                                                    :solar-azimuth="plot.config.solarAzimuth"
                                                    :solar-irradiance="plot.config.solarIrradiance"
                                                    :solar-transmittance="plot.config.solarTransmittance"
                                                    :f_svv="plot.config.f_svv"
                                                    :f_bes="plot.config.f_bes"
                                                    :asw="plot.config.asw"
                            ></thermal-comfort-widget>
                            <cost-breakdown-widget v-if="plot.type==='cost-breakdown-widget'"
                                                   :height="plot.config.height"
                                                   :leftmarg="plot.config.leftmarg"
                                                   :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                   :white-mode="whiteMode"
                                                   :date-range="range"></cost-breakdown-widget>
                            <custom-ec-widget v-if="plot.type==='custom-ec-widget'"
                                              :style="plot.config.verticalOffset ? 'height:0px;' : ''"
                                              :vertical-offset="plot.config.verticalOffset"
                                              :date-range="range"
                                              :processor-function="plot.config.processorFunction"
                                              :data3query="plot.config.data3query"
                                              :no-reload="plot.config.noReload"
                                              :start-hidden-equip="plot.config.startHiddenEquip"
                                              :parameters="parameters"
                                              :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                              :enable-merge="plot.config.disableMerge"
                                              :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :timer="plot.config.timer"
                                              :animation-mode="plot.config.animationMode"
                                              :white-mode="whiteMode"
                                              :show-errors="debugMode"
                                              :height="plot.config.height"
                                              :settings="plot.config.settings"
                            ></custom-ec-widget>
                            <optimization-control-widget v-if="plot.type==='optimization-control-widget'" :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                         :date-range="range"
                                                         :white-mode="whiteMode"
                                                         :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                                         :default-equipment="plot.config.defaultEquipment"
                                                         :follow-equipment="plot.config.followEquipment"
                                                         :use-relationship="plot.config.useRelationship"
                                                         :relationship-type="plot.config.relationshipType"
                                                         :show-priorities="plot.config.showPriorities"
                                                         :specific-sensors="plot.config.specificSensors"
                                                         :col-width="plot.config.colWidth"
                                                         :equipment-col-width="plot.config.equipmentColWidth"
                                                         :show-missing-sensors="debugMode"
                            ></optimization-control-widget>
                            <data-export-widget v-if="plot.type==='data-export-widget'"
                                              :date-range="range"
                                              :data3query="plot.config.data3query"
                                              :parameters="parameters"
                                                :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                              :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :title="plot.config.title"
                                                :file-name="plot.config.fileName"
                                                :include-range-in-name="plot.config.includeRangeInName"
                            ></data-export-widget>
                            <optimization-viz-widget v-if="plot.type==='optimization-viz-widget'"  :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                     :date-range="range"
                                                     :data3query="plot.config.data3query"
                                                     :parameters="parameters"
                                                     :equipment="plot.forcedEquip ? plot.forcedEquip: equip"
                                                     :title="plot.config.title"
                                                     :target="plot.config.target"
                                                     :white-mode="whiteMode"
                                                     :height="plot.config.height"
                                                     :increment="plot.config.increment"
                            ></optimization-viz-widget>
                            <solar-widget v-if="plot.type==='solar-widget'"
                                          :height="plot.config.height"
                                          :lat="plot.config.lat"
                                          :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                          :lon="plot.config.lon"
                                          :features-json="plot.config.featuresJson"
                                          :date-range="range"
                                          :white-mode="whiteMode"
                                          :show-clock="plot.config.showClock"
                                          :main-intensity="plot.config.mainIntensity"
                                          :ambient-intensity="plot.config.ambientIntensity"
                            ></solar-widget>
                            <autotuner-widget v-if="plot.type==='autotuner-widget'"
                                              :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :height="plot.config.height"
                                              :autotuner-id="plot.config.autotunerId"
                                              :title="plot.config.title"
                                              :date-range="range"
                                              :white-mode="whiteMode"
                            ></autotuner-widget>
                            <form-widget v-if="plot.type==='form-widget'"
                                              :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :title="plot.config.title"
                                              :table-mode="plot.config.tableMode"
                                              :description="plot.config.description"
                                         :multiple-mode="plot.config.multipleMode"
                                              :fields="plot.config.fields"
                            ></form-widget>
                            <equipment-graphic-renderer v-if="plot.type==='graphic-widget'" :graphic-id="plot.config.graphic_id"
                                                        :menu-mode="plot.config.menuMode"
                                                        :menu-path="plot.config.menuPath"
                                                        :in-page-menu="plot.config.inPageMenu"
                                                        @forceselectequipment="forceSelectEquip"
                                                        :class="(itemDefinition.showBoxes||plot.showBox)&&!itemDefinition.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :health-mode="plot.config.healthMode"
                                                        :use-min-height="plot.config.useMinHeight"
                                                        :lighting-preset="plot.config.lightingPreset"
                                                        :height="plot.config.height"
                                                        :ground-shadow="plot.config.groundShadow"
                                                        :ground-reflection="plot.config.groundReflection"
                                                        :node-names-to-hide="plot.config.nodeNamesToHide"
                                                        :node-names-to-remove="plot.config.nodeNamesToRemove"
                                                        :mode-name-to-focus="plot.config.modeNameToFocus"
                                                        :forced-background="plot.config.forcedBackground"
                                                        :lock-nav="plot.config.lockNav"
                                                        :date-range="range"></equipment-graphic-renderer>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions v-if="!embeddedMode&&!fullscreenMode" :style="itemDefinition.showBoxes&&!itemDefinition.renderAsReport&&itemDefinition.backgroundColor ? 'background-color:'+itemDefinition.backgroundColor : ''">
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           class="elevation-4"
                           @click="qrDialog=true"
                    >
                        {{'Get Link'|translate}}
                    </v-btn>
                    <v-btn color="primary" v-if="!mobileMode&&!smallScreen"
                           class="elevation-4"
                           @click="exportAll()"
                    >
                        {{'Export charts as PDF'|translate}}
                    </v-btn>
                    <v-btn color="primary" class="mr-2 elevation-4" v-if="!itemDefinition.renderAsReport&&!reportIsPrinting&&!mobileMode&&!smallScreen" id="printer"
                           @click="printAll()"
                    >
                        {{'Export all as PDF'|translate}}
                    </v-btn>
                    <v-btn color="primary" @click="printReportPDF()" v-if="itemDefinition.renderAsReport&&!reportIsPrinting&&!mobileMode&&!smallScreen" id="printer" class="elevation-4">
                        {{'Export all as PDF'|translate}}
                    </v-btn>
                    <v-progress-circular indeterminate class="mr-5 ml-5" v-if="reportIsPrinting" size="18"></v-progress-circular>
                    <v-btn color="primary" @click="openInEditor(itemDefinition.id)" v-if="$can('update', 'Config')&&itemDefinition.id&&!mobileMode&&!smallScreen" class="elevation-4">
                        {{'Edit'|translate}}
                    </v-btn>
                    <v-tooltip bottom v-if="itemDefinition.id&&!mobileMode&&!smallScreen&&!reportIsPrinting&&canToggleDebug">
                        <template v-slot:activator="{ on }" >
                            <v-icon
                                class="mr-2 ml-3"
                                :color="debugMode ? 'success' : null"
                                small
                                v-on="on"
                                @click="debugMode=!debugMode;"
                            >
                                fa-bug
                            </v-icon>
                        </template>
                        <span>{{'Toggle debug mode'|translate}}</span>
                    </v-tooltip>
                  <v-dialog v-model="qrDialog" :max-width="!mobileMode&&!smallScreen ? 544 : 290">
                    <v-card v-if="qrDialog">
                      <v-card-text>
                        <v-layout row class="pa-2">
                          <h3>{{qrCodeText}} </h3>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }" >
                              <v-icon
                                  class="ml-3"
                                  small
                                  v-on="on"
                                  @click.stop="$copyText(qrCodeText)"
                              >
                                fa-copy
                              </v-icon>
                            </template>
                            <span>{{'Copy to clipboard'|translate}}</span>
                          </v-tooltip>
                        </v-layout>
                        <qr-code :text="qrCodeText" :size="!mobileMode&&!smallScreen ? 512 : 256"></qr-code>
                      </v-card-text>
                    </v-card>
                  </v-dialog>

                </v-card-actions>
            </v-card>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import DateRangeSelector from '../../components/DateRangeSelector'
    import EquipmentSelector from '../../components/EquipmentSelector'
    import exportAllToPDF from '../../components/mixins/exportAllToPDF'
    import printer from "../../components/mixins/printer";
    import reportPrinter from '../../components/mixins/reportPrinter'
    import Data3Chart from "../../components/Data3Chart";
    import MapWidget from "../../components/widgets/MapWidget";
    import HeatmapWidget from "../../components/widgets/HeatmapWidget";
    import CorrelationWidget from "../../components/widgets/CorrelationWidget";
    import OptimizationWidget from "../../components/widgets/OptimizationWidget";
    import FaultBreakdownWidget from "../../components/widgets/FaultBreakdownWidget";
    import CopSavingsWidget from "../../components/widgets/CopSavingsWidget";
    import FaultEvalWidget from "../../components/widgets/FaultEvalWidget";
    import StagingProfileWidget from "../../components/widgets/StagingProfileWidget";
    import CoolingLoadForecastWidget from '../../components/widgets/CoolingLoadForecastWidget'
    import ChillerSequencingFlaWidget from '../../components/widgets/ChillerSequencingFLAWidget'
    import ChillerSequencingDeltaWidget from '../../components/widgets/ChillerSequencingDeltaWidget'
    import CoolingLoadVsOatWidget from '../../components/widgets/CoolingLoadVsOatWidget'
    import BmsWidget from "@/components/widgets/BmsWidget";
    import ForgeViewerWidget from "@/components/widgets/ForgeViewerWidget";
    import ForgeViewerHeatmapWidget from "@/components/widgets/ForgeViewerHeatmapWidget";
    import MaintenanceSummaryWidget from "@/components/widgets/MaintenanceSummaryWidget";
    import CostBreakdownWidget from "@/components/widgets/CostBreakdownWidget";
    import SvgWidget from "@/components/widgets/SvgWidget";
    import IssueSummaryWidget from "@/components/widgets/IssueSummaryWidget";
    import TreeMapWidget from "@/components/widgets/TreeMapWidget";
    import FlexibleOptimizationWidget from "@/components/widgets/FlexibleOptimizationWidget";
    import CustomEcWidget from "../../components/widgets/CustomEcWidget";
    import EquipmentGraphicRenderer from "../../components/EquipmentGraphicRenderer";
    import FlexibleCopSavingsWidget from "../../components/widgets/FlexibleCopSavingsWidget";
    import FaultsReportWidget from "../../components/widgets/FaultsReportWidget";
    import NotifBreakdownWidget from "../../components/widgets/NotifBreakdownWidget";
    import SensorCalibrationWidget from "../../components/widgets/SensorCalibrationWidget";
    import SolarWidget from "../../components/widgets/SolarWidget";
    import AutotunerWidget from "../../components/widgets/AutotunerWidget";
    import ThermalComfortWidget from "../../components/widgets/ThermalComfortWidget";
    import DataExportWidget from "../../components/widgets/DataExportWidget.vue";
    import OptimizationControlWidget from "../../components/widgets/OptimizationControlWidget.vue";
    import optimizationVizWidget from "../../components/widgets/OptimizationVizWidget.vue";
    import ClockControlWidget from "../../components/widgets/ClockControlWidget.vue";
    import FormWidget from "@/components/widgets/FormWidget.vue";
    import moment from 'moment'

    export default {
        name: 'PlotList',
        components: {
            FaultEvalWidget,
            EquipmentSelector,
            DateRangeSelector,
            Data3Chart,
            MapWidget,
            HeatmapWidget,
            CorrelationWidget,
            OptimizationWidget,
            FaultBreakdownWidget,
            CopSavingsWidget,
            StagingProfileWidget,
            CoolingLoadForecastWidget,
            ChillerSequencingFlaWidget,
            ChillerSequencingDeltaWidget,
            CoolingLoadVsOatWidget,
            BmsWidget,
            ForgeViewerWidget,
            ForgeViewerHeatmapWidget,
            MaintenanceSummaryWidget,
            CostBreakdownWidget,
            SvgWidget,
            IssueSummaryWidget,
            TreeMapWidget,
            FlexibleOptimizationWidget,
            CustomEcWidget,
            EquipmentGraphicRenderer,
            FlexibleCopSavingsWidget,
            FaultsReportWidget,
            NotifBreakdownWidget,
            SensorCalibrationWidget,
            SolarWidget,
            AutotunerWidget,
            ThermalComfortWidget,
            DataExportWidget,
            OptimizationControlWidget,
            optimizationVizWidget,
            ClockControlWidget,
            FormWidget,
        },
        props: {
            itemDefinition: {type: Object, default: null},
            rangeOverride:{type: Object, default: null},
            embeddedMode:{type: Boolean, default: false},
            fullscreenMode:{type: Boolean, default: false},
            embeddedEquip:{type: String, default: null},
        },
        mixins:[exportAllToPDF,printer,reportPrinter],
        data() {
            return {
                equip: null,
                range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                onOnly: false,
                reportIsPrinting:false,
                debugMode:false,
                qrDialog:false,
                reloadingSelectors:false,
                interval:null,
                parameters:{},
            }
        },
        computed: {
            canToggleDebug(){
                if (this.$store.state.userStore.user) {
                    if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                        return true
                    } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                        return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                    } else {
                        return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                    }
                }
                return false;
            },
            allEquipsMode(){
                return this.itemDefinition&&this.itemDefinition.hasEquipmentSelector&&this.itemDefinition.allEquipsMode
            },
            currentViewComponents(){
                if (this.allEquipsMode){
                    let newlist=[]
                    let originalList=JSON.parse(JSON.stringify(this.itemDefinition.plotList))
                    let equips=Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)
                    if (this.itemDefinition.equipmentTypeFilter){
                        equips=equips.filter(e=>e.equipment_type&&e.equipment_type.toLowerCase()===this.itemDefinition.equipmentTypeFilter.toLowerCase())
                    }
                    if (this.itemDefinition.equipmentFloorFilter){
                        equips=equips.filter(e=>e.floor===this.itemDefinition.equipmentFloorFilter)
                    }
                    if (this.itemDefinition.equipmentTagFilter&&this.itemDefinition.equipmentTagFilter!==""){
                        let requiredTags=this.itemDefinition.equipmentTagFilter.split(",")
                        equips=equips.filter(e=>e.equipment_tags&&requiredTags.every(tag=>e.equipment_tags.includes(tag)))
                    }
                    equips=equips.map(e=>e.equipment_name)
                    equips.sort()
                    for (let equip of equips){
                        for (let plot of originalList){
                            let newPlot=JSON.parse(JSON.stringify(plot))
                            newPlot.forcedEquip=equip
                            newPlot.id=plot.id+"_"+equip
                            newlist.push(newPlot)
                        }
                    }
                    return newlist
                }
                return this.itemDefinition.plotList
            },
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },
            whiteMode(){
                return (this.itemDefinition&&this.itemDefinition.whiteMode)||!this.unifiedIsThemeDark
            },
            mobileMode(){
                return process.env.VUE_APP_MOBILE_MODE ? process.env.VUE_APP_MOBILE_MODE : false
            },
          smallScreen(){
              return window&&window.innerWidth<720
          },
            enforceMinWidth(){
                return this.itemDefinition&&this.itemDefinition.enforceMinWidth&&!this.itemDefinition.renderAsReport&&!this.mobileMode&&window.innerWidth>1264
            },
             qrCodeText(){
               let route=JSON.parse(JSON.stringify({path:this.$router.currentRoute.path,query:this.$router.currentRoute.query}))
               if(route.query){
                 delete(route.query.rangeEnd)
                 delete(route.query.rangeStart)
               }
               return window.location.origin+this.$router.resolve(route).href
            },
        },
        watch: {
            range () {
                this.updateQueryString()
            },
            equip () {
                this.updateQueryString()
            },
            itemDefinition(){
                this.runCleanup()
            },
            embeddedEquip(){
                if (this.embeddedMode){
                    this.equip=this.embeddedEquip
                }
            }
        },
        methods:{
            forceSelectEquip(equip){
                this.equip=equip
            },
            splitHTML(html){
                let doc = new DOMParser().parseFromString(html, 'text/html');
                return [...doc.body.childNodes].map(child => child.outerHTML);
            },
            openInEditor(id){
                let url='/custom-view-builder?view='+id
                if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                    window.location.href=url
                } else {
                    window.open(url)
                }
            },
          async exportAll() {
            let title = this.facility_name + "=" + this.range.start
            this.exportAllItems(this.$refs.plots, title);
          },
            async sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms))
            },
            async printAll() {
                let title = this.facility_name + "=" + this.range.start
                this.reportIsPrinting = true
                await this.sleep(300)
                await this.printPage('.carnot-custom-view', title,this.whiteMode)
                this.reportIsPrinting = false
            },
            async printReportPDF() {
                this.reportIsPrinting = true
                let filename=this.itemDefinition.title
                if (this.equip&&this.equip!==""){
                    filename=filename+" - "+this.equip
                }
                await this.sleep(300)
                await this.generateReportPDF(this.itemDefinition.title, this.itemDefinition.subtitle,this.whiteMode,this.itemDefinition.brandName,this.itemDefinition.disableCoverPage,this.itemDefinition.customLogo,filename)
                this.reportIsPrinting = false
          },
            updateQueryString() {
                if (!this.embeddedMode) {
                    let query={
                        rangeStart: this.range.start,
                        rangeEnd: this.range.end,
                    }
                    if (this.equip&&this.equip!==""){
                        query.equipment=this.equip
                    }
                    this.$router.replace({
                        path: this.$router.currentRoute.path,
                        query: query
                    }).catch(err => {
                    })
                }
            },
            runCleanup(){
                this.reloadingSelectors=true
                clearInterval(this.interval)
                if (this.embeddedMode&&this.embeddedEquip){
                    this.equip=this.embeddedEquip
                } else {
                    this.equip=_.get(this.$route.query, 'equipment', null)
                }
                if(this.rangeOverride){
                    this.range = this.rangeOverride
                } else {
                    let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                    let rangeStart = _.get(this.$route.query, 'rangeStart', null)
                    let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
                    if (this.itemDefinition.defaultRange&&this.itemDefinition.defaultRange==="live"){
                        let me = this
                        me.range={start:moment().subtract(4,"hours").startOf("hour").format('YYYY-MM-DD HH:mm:ss'),end:moment().endOf("hour").format('YYYY-MM-DD HH:mm:ss')}
                        me.interval=setInterval(function() {
                            me.range={start:moment().subtract(4,"hours").startOf("hour").format('YYYY-MM-DD HH:mm:ss'),end:moment().endOf("hour").format('YYYY-MM-DD HH:mm:ss')}
                        }, Math.round(3600000/(me.$store.state.pointsListStore.pointsList.sampling_freq*3)));
                    } else if (!!rangeStart) {
                        this.range = {start: rangeStart, end: rangeEnd}
                    } else if (this.itemDefinition.defaultRange&&this.itemDefinition.defaultRange!==""&&this.itemDefinition.defaultRange!=="30 days"){
                        if(this.itemDefinition.defaultRange==="this range"){
                            this.range=JSON.parse(JSON.stringify(this.itemDefinition.range))
                        } else {
                            let baseDate=moment()
                            if(maxDate){
                                baseDate=moment(maxDate)
                            }
                            let startDate=baseDate.clone().subtract(30, "days")
                            if(this.itemDefinition.defaultRange==="current week"){
                                startDate=baseDate.clone().startOf("week")
                            } else if(this.itemDefinition.defaultRange==="current month"){
                                startDate=baseDate.clone().startOf("month")
                            } else if(this.itemDefinition.defaultRange==="today"){
                                startDate=baseDate.clone().startOf("day")
                            } else if(this.itemDefinition.defaultRange==="current year"){
                                startDate=baseDate.clone().startOf("year")
                            } else if(this.itemDefinition.defaultRange==="last week"){
                                baseDate=baseDate.subtract(1,"week").endOf("week")
                                startDate=baseDate.clone().startOf("week")
                            }else if(this.itemDefinition.defaultRange==="last month"){
                                baseDate=baseDate.subtract(1,"month").endOf("month")
                                startDate=baseDate.clone().startOf("month")
                            }else if(this.itemDefinition.defaultRange==="yesterday"){
                                baseDate=baseDate.subtract(1,"day").endOf("day")
                                startDate=baseDate.clone().startOf("day")
                            }else if(this.itemDefinition.defaultRange==="last year"){
                                baseDate=baseDate.subtract(1,"year").endOf("year")
                                startDate=baseDate.clone().startOf("year")
                            }
                            if(this.itemDefinition.defaultRange==="yesterday"||this.itemDefinition.defaultRange==="today"){
                                this.range={start:startDate.format('YYYY-MM-DD HH:mm:ss'),end:baseDate.format('YYYY-MM-DD HH:mm:ss')}
                            } else {
                                this.range={start:startDate.format('YYYY-MM-DD'),end:baseDate.format('YYYY-MM-DD')}
                            }
                        }
                    }else if(maxDate){
                        this.range={start:moment(maxDate).subtract(29, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
                    }
                }
                let parameters={}
                for (let plot of this.itemDefinition.plotList){
                    if(plot.type==="parameter-widget"&&plot.config.fields){
                        for (let field of plot.config.fields){
                            if(field.name){
                                parameters[field.name]=field.defaultValue
                            }
                        }
                    }
                }
                this.parameters=parameters
                let me=this
                setTimeout(() => {
                    me.reloadingSelectors=false
                }, 50);
            }
        },
        beforeDestroy: function(){
            clearInterval(this.interval)
        },
        beforeMount() {
            this.runCleanup()
        }
    }
</script>
<style>
    .carnot-custom-report{
        width: 900px;
        margin-left: auto;
        margin-right: auto;
    }
    .carnot-custom-report-white{
        background-color: white !important;
    }
    :root {
        --ck-color-image-caption-background: hsl(0, 0%, 97%);
        --ck-color-image-caption-text: hsl(0, 0%, 20%);
        --ck-color-mention-background: hsla(341, 100%, 30%, 0.1);
        --ck-color-mention-text: hsl(341, 100%, 30%);
        --ck-color-table-caption-background: hsl(0, 0%, 97%);
        --ck-color-table-caption-text: hsl(0, 0%, 20%);
        --ck-highlight-marker-blue: hsl(201, 97%, 72%);
        --ck-highlight-marker-green: hsl(120, 93%, 68%);
        --ck-highlight-marker-pink: hsl(345, 96%, 73%);
        --ck-highlight-marker-yellow: hsl(60, 97%, 73%);
        --ck-highlight-pen-green: hsl(112, 100%, 27%);
        --ck-highlight-pen-red: hsl(0, 85%, 49%);
        --ck-image-style-spacing: 1.5em;
        --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
        --ck-todo-list-checkmark-size: 16px;
    }
    /* ckeditor5-image/theme/imagecaption.css */
    .ck-rendered-content .image > figcaption {
        display: table-caption;
        caption-side: bottom;
        word-break: break-word;
        color: var(--ck-color-image-caption-text);
        background-color: var(--ck-color-image-caption-background);
        padding: .6em;
        font-size: .75em;
        outline-offset: -1px;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-left,
    .ck-rendered-content .image-style-block-align-right {
        max-width: calc(100% - var(--ck-image-style-spacing));
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-left,
    .ck-rendered-content .image-style-align-right {
        clear: none;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-side {
        float: right;
        margin-left: var(--ck-image-style-spacing);
        max-width: 50%;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-left {
        float: left;
        margin-right: var(--ck-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-center {
        margin-left: auto;
        margin-right: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-right {
        float: right;
        margin-left: var(--ck-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-right {
        margin-right: 0;
        margin-left: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-left {
        margin-left: 0;
        margin-right: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content p + .image-style-align-left,
    .ck-rendered-content p + .image-style-align-right,
    .ck-rendered-content p + .image-style-side {
        margin-top: 0;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-left,
    .ck-rendered-content .image-inline.image-style-align-right {
        margin-top: var(--ck-inline-image-style-spacing);
        margin-bottom: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-left {
        margin-right: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-right {
        margin-left: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-tiny {
        font-size: .7em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-small {
        font-size: .85em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-big {
        font-size: 1.4em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-huge {
        font-size: 1.8em;
    }
    /* ckeditor5-horizontal-line/theme/horizontalline.css */
    .ck-rendered-content hr {
        margin: 15px 0;
        height: 4px;
        background: hsl(0, 0%, 87%);
        border: 0;
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-yellow {
        background-color: var(--ck-highlight-marker-yellow);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-green {
        background-color: var(--ck-highlight-marker-green);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-pink {
        background-color: var(--ck-highlight-marker-pink);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-blue {
        background-color: var(--ck-highlight-marker-blue);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .pen-red {
        color: var(--ck-highlight-pen-red);
        background-color: transparent;
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .pen-green {
        color: var(--ck-highlight-pen-green);
        background-color: transparent;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image {
        display: table;
        clear: both;
        text-align: center;
        margin: 0.9em auto;
        min-width: 50px;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
        min-width: 100%;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline {
        /*
         * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).;
         * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.
         * This strange behavior does not happen with inline-flex.
         */
        display: inline-flex;
        max-width: 100%;
        align-items: flex-start;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline picture {
        display: flex;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline picture,
    .ck-rendered-content .image-inline img {
        flex-grow: 1;
        flex-shrink: 1;
        max-width: 100%;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized {
        max-width: 100%;
        display: block;
        box-sizing: border-box;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized img {
        width: 100%;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized > figcaption {
        display: block;
    }
    /* ckeditor5-block-quote/theme/blockquote.css */
    .ck-rendered-content blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        margin-right: 0;
        font-style: italic;
        border-left: solid 5px hsl(0, 0%, 80%);
    }
    /* ckeditor5-block-quote/theme/blockquote.css */
    .ck-rendered-content[dir="rtl"] blockquote {
        border-left: 0;
        border-right: solid 5px hsl(0, 0%, 80%);
    }
    /* ckeditor5-basic-styles/theme/code.css */
    .ck-rendered-content code {
        background-color: hsla(0, 0%, 78%, 0.3);
        padding: .15em;
        border-radius: 2px;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table {
        margin: 0.9em auto;
        display: table;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        height: 100%;
        border: 1px double hsl(0, 0%, 70%);
    }
    .split-ck-rendered-content .ck-rendered-content .table table {
        margin-bottom: 20px;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table td,
    .ck-rendered-content .table table th {
        min-width: 2em;
        padding: .4em;
        border: 1px solid hsl(0, 0%, 75%);
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table th {
        font-weight: bold;
        background: hsla(0, 0%, 0%, 5%);
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content[dir="rtl"] .table th {
        text-align: right;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content[dir="ltr"] .table th {
        text-align: left;
    }
    /* ckeditor5-table/theme/tablecaption.css */
    .ck-rendered-content .table > figcaption {
        display: table-caption;
        caption-side: top;
        word-break: break-word;
        text-align: center;
        color: var(--ck-color-table-caption-text);
        background-color: var(--ck-color-table-caption-background);
        padding: .6em;
        font-size: .75em;
        outline-offset: -1px;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break {
        position: relative;
        clear: both;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break::after {
        content: '';
        position: absolute;
        border-bottom: 2px dashed hsl(0, 0%, 77%);
        width: 100%;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break__label {
        position: relative;
        z-index: 1;
        padding: .3em .6em;
        display: block;
        text-transform: uppercase;
        border: 1px solid hsl(0, 0%, 77%);
        border-radius: 2px;
        font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;
        font-size: 0.75em;
        font-weight: bold;
        color: hsl(0, 0%, 20%);
        background: hsl(0, 0%, 100%);
        box-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    /* ckeditor5-media-embed/theme/mediaembed.css */
    .ck-rendered-content .media {
        clear: both;
        margin: 0.9em 0;
        display: block;
        min-width: 15em;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list {
        list-style: none;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list li {
        margin-bottom: 5px;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list li .todo-list {
        margin-top: 5px;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input {
        -webkit-appearance: none;
        display: inline-block;
        position: relative;
        width: var(--ck-todo-list-checkmark-size);
        height: var(--ck-todo-list-checkmark-size);
        vertical-align: middle;
        border: 0;
        left: -25px;
        margin-right: -15px;
        right: 0;
        margin-left: 0;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input::before {
        display: block;
        position: absolute;
        box-sizing: border-box;
        content: '';
        width: 100%;
        height: 100%;
        border: 1px solid hsl(0, 0%, 20%);
        border-radius: 2px;
        transition: 250ms ease-in-out box-shadow, 250ms ease-in-out background, 250ms ease-in-out border;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input::after {
        display: block;
        position: absolute;
        box-sizing: content-box;
        pointer-events: none;
        content: '';
        left: calc( var(--ck-todo-list-checkmark-size) / 3 );
        top: calc( var(--ck-todo-list-checkmark-size) / 5.3 );
        width: calc( var(--ck-todo-list-checkmark-size) / 5.3 );
        height: calc( var(--ck-todo-list-checkmark-size) / 2.6 );
        border-style: solid;
        border-color: transparent;
        border-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;
        transform: rotate(45deg);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input[checked]::before {
        background: hsl(126, 64%, 41%);
        border-color: hsl(126, 64%, 41%);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input[checked]::after {
        border-color: hsl(0, 0%, 100%);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label .todo-list__label__description {
        vertical-align: middle;
    }
    /* ckeditor5-language/theme/language.css */
    .ck-rendered-content span[lang] {
        font-style: italic;
    }
    /* ckeditor5-code-block/theme/codeblock.css */
    .ck-rendered-content pre {
        padding: 1em;
        color: hsl(0, 0%, 20.8%);
        background: hsla(0, 0%, 78%, 0.3);
        border: 1px solid hsl(0, 0%, 77%);
        border-radius: 2px;
        text-align: left;
        direction: ltr;
        tab-size: 4;
        white-space: pre-wrap;
        font-style: normal;
        min-width: 200px;
    }
    /* ckeditor5-code-block/theme/codeblock.css */
    .ck-rendered-content pre code {
        background: unset;
        padding: 0;
        border-radius: 0;
    }
    /* ckeditor5-mention/theme/mention.css */
    .ck-rendered-content .mention {
        background: var(--ck-color-mention-background);
        color: var(--ck-color-mention-text);
    }
    .generic-styled-table {
        border-collapse: collapse;
        margin: 25px 0;
        margin-left:auto;
        margin-right:auto;
        font-size: 0.9em;
        font-family: sans-serif;
        min-width: 400px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    }
    .generic-styled-table thead tr {
        color: #FFFFFF;
        font-size:1.1em;
        font-weight: bold;
        background-color: rgb(96,96,96);
    }
    .generic-styled-table thead tr:first-of-type{
        border-top: 1px solid #424242;
        text-align: left;
    }
    .generic-styled-table thead tr:last-of-type{
        border-bottom: 1px solid #424242;
    }
    .generic-styled-table td:last-of-type,
    .generic-styled-table th:last-of-type {
        border-right: 1px solid #424242;
    }
    .generic-styled-table td,
    .generic-styled-table th {
        padding: 10px 15px;
        text-align: center;
        border-left: 1px solid #424242;
    }
    .generic-styled-table tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    .generic-styled-table tbody tr:nth-of-type(even) {
        background-color: #f3f3f3;
        color:#424242;
    }
    .generic-styled-table tbody tr:nth-of-type(odd) {
        background-color: rgb(180,180,180);
        color:#FFFFFF;
    }

    .generic-styled-table tbody tr:nth-of-type(even) .text-right-tablefield .v-input__control .v-input__slot input {
        background-color: #f3f3f3;
        color:#424242;
    }
    .generic-styled-table tbody tr:nth-of-type(even) .table-form-icon{
        color:#424242 !important;
    }

    .generic-styled-table tbody tr:last-of-type {
        border-bottom: 1px solid #424242;
    }
    .generic-styled-title{
        font-family:  helvetica, arial, sans-serif;
        font-weight:900; font-style:regular;
        width: 100%;
        padding-bottom: 10px;
        color: #FFFFFF;
        text-align: left;
    }
    .generic-styled-bar{
        border: 2px solid #CCCCCC;
        border-radius: 5px;
    }
    @media print {
        /* ckeditor5-page-break/theme/pagebreak.css */
        .ck-rendered-content .page-break {
            padding: 0;
        }
        /* ckeditor5-page-break/theme/pagebreak.css */
        .ck-rendered-content .page-break::after {
            display: none;
        }
    }
</style>
